<template>
  <v-container>
    <h1>Account Settings</h1>
    <h2 class="pt-3">Email &amp; Security</h2>
    <v-row no-gutters class="d-none d-md-flex">
      <v-col>
        <change-email-form></change-email-form>
      </v-col>
      <v-divider vertical></v-divider>
      <v-col>
        <password-change-form></password-change-form>
      </v-col>
    </v-row>
    <v-row no-gutters class="d-flex d-md-none">
      <v-col cols="12">
        <change-email-form></change-email-form>
      </v-col>
      <v-spacer></v-spacer>
      <v-col cols="12">
        <password-change-form></password-change-form>
      </v-col>
    </v-row>
    <v-divider class="my-6"></v-divider>
    <h2>Payment Methods</h2>
    <v-list>
      <v-list-item v-for="paymentMethod in paymentMethods" :key="paymentMethod.id">
        <v-list-item-icon>
          <v-img :src="`/icons/credit_cards/png/24/${paymentMethod.card.brand}.png`"></v-img>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>
            <span class="text-capitalize font-weight-bold">{{paymentMethod.card.brand}}</span> ending in {{paymentMethod.card.last4}}
          </v-list-item-title>
          <v-list-item-subtitle>
            Expiration: {{paymentMethod.card.expMonth}}/{{paymentMethod.card.expYear}}
          </v-list-item-subtitle>
        </v-list-item-content>
        <v-list-item-action>
          <remove-payment-method-dialog :paymentMethod="paymentMethod"></remove-payment-method-dialog>
        </v-list-item-action>
      </v-list-item>
    </v-list>
  </v-container>
</template>

<script>
import PasswordChangeForm from '@/components/PasswordChangeForm.vue';
import { mapActions } from "vuex";
import ChangeEmailForm from '@/components/ChangeEmailForm.vue';
import RemovePaymentMethodDialog from '@/components/RemovePaymentMethodDialog.vue';

export default {
  name: "AccountSettings",
  components: {PasswordChangeForm, ChangeEmailForm, RemovePaymentMethodDialog},
  computed: {
    paymentMethods() {
      return this.$store.state.auth.user.djstripeCustomers[0].paymentMethods
    }
  },
  mounted() {
    this.updateWindowTitle({ newTitle: "Account Settings" });
  },
  methods: {
    ...mapActions(["updateWindowTitle"]),
    removePaymentMethod(id) {
      return id
    }
  },
};
</script>
